import { useEffect, useRef } from 'react';

/**
 * Dispara `track` una vez por cada `key` distinta mientras la pantalla está montada;
 * con `key` en `null` espera. Es la integración con analytics de una vista que
 * depende de datos que llegan después del montaje.
 */
export const useTrackView = (key: string | null, track: () => void) => {
  const lastKey = useRef<string | null>(null);
  useEffect(() => {
    if (key === null || lastKey.current === key) return;
    lastKey.current = key;
    track();
  }, [key, track]);
};
